import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-604521fa")
const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title-line" }, [
  /*#__PURE__*/_createElementVNode("span", null, "我的基地")
], -1)
const _hoisted_3 = { class: "land-container" }
const _hoisted_4 = { class: "right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icons-font",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-nonghu1" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "icons-font",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-ditu1" })
  ]),
  /*#__PURE__*/_createTextVNode(" 0km ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "title-line" }, [
  /*#__PURE__*/_createElementVNode("span", null, "农事任务")
], -1)
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "item-btn" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "right" }
const _hoisted_14 = { style: {"margin-right":"1rem"} }
const _hoisted_15 = { class: "bottom-info" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "right" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "icons-font",
    style: {"margin-right":"0.2rem"},
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-tupian" })
  ]),
  /*#__PURE__*/_createTextVNode("图片教学 "),
  /*#__PURE__*/_createElementVNode("svg", {
    class: "icons-font",
    style: {"margin-right":"0.2rem","margin-left":"0.5rem"},
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-video" })
  ]),
  /*#__PURE__*/_createTextVNode("视频教学 ")
], -1)
const _hoisted_19 = {
  key: 0,
  class: "info-text"
}
const _hoisted_20 = { class: "bottom--menu" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_hori_slide = _resolveComponent("hori-slide")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_pull_refresh, {
      modelValue: _ctx.loading,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.loading = $event)),
      onRefresh: _ctx.onRefresh
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_van_swipe, {
          class: "my-swipe",
          "show-indicators": false,
          autoplay: 3000
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resourceData, (item) => {
              return (_openBlock(), _createBlock(_component_van_swipe_item, {
                key: item.id
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_van_image, {
                      radius: "8px",
                      src: 
                item.images.length > 0
                  ? item.images[0].url + '?imageView2/1/w/200/h/200/rotate/0'
                  : ''
              ,
                      class: "left",
                      onClick: ($event: any) => (
                _ctx.preview(
                  item.images && item.images[0] ? item.images[0].url : undefined
                )
              )
                    }, null, 8, ["src", "onClick"]),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", null, _toDisplayString(item.sourceName), 1),
                      _hoisted_5,
                      _createElementVNode("div", null, "预计产量：" + _toDisplayString(item.yield) + "斤", 1),
                      _createElementVNode("div", null, [
                        _hoisted_6,
                        _createTextVNode(_toDisplayString(item.farmerInfo.farmerName), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createTextVNode(_toDisplayString(item.addressInfo) + " ", 1),
                        _hoisted_7
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _hoisted_8,
        _createVNode(_component_hori_slide, { onBottom: _ctx.onBottom }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.farmingDataList, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "slide-item",
                key: item.id
              }, [
                _createElementVNode("div", {
                  class: "item-title",
                  onClick: ($event: any) => (_ctx.onShowDetail(item))
                }, [
                  _createElementVNode("span", null, "操作开始时间：" + _toDisplayString(item.optionTime), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, _toDisplayString(item.status == 0
                    ? "未操作"
                    : item.status == 1
                    ? "已完成"
                    : item.status == 2
                    ? "已忽略"
                    : ""), 1),
                    (item.outTime > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, "逾期" + _toDisplayString(item.outTime) + "天", 1))
                      : _createCommentVNode("", true)
                  ])
                ], 8, _hoisted_9),
                _createElementVNode("div", {
                  class: "product-item",
                  onClick: ($event: any) => (_ctx.onShowDetail(item))
                }, [
                  _createVNode(_component_van_image, {
                    class: "left",
                    src: item.typeImg + '?imageView2/1/w/100/h/100/rotate/0',
                    onClick: ($event: any) => (_ctx.preview(item.typeImg ? item.typeImg : undefined))
                  }, null, 8, ["src", "onClick"]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", null, _toDisplayString(item.typeName), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_14, "地块编码：" + _toDisplayString(item.areaCode), 1),
                      _createElementVNode("span", null, "种植面积：" + _toDisplayString(item.areaArea) + "亩", 1)
                    ])
                  ])
                ], 8, _hoisted_12),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", {
                    class: "phenodate",
                    onClick: ($event: any) => (_ctx.onShowDetail(item))
                  }, [
                    _createVNode(_component_van_image, {
                      radius: "5px",
                      class: "left",
                      src: 
                  item.plantFarmingImg &&
                  item.plantFarmingImg.split(',').length > 0
                    ? item.plantFarmingImg.split(',')[0] +
                      '?imageView2/1/w/200/h/200/rotate/0'
                    : ''
                ,
                      onClick: ($event: any) => (
                  _ctx.preview(
                    item.plantFarmingImg && item.plantFarmingImg.split(',')
                  )
                )
                    }, null, 8, ["src", "onClick"]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", null, _toDisplayString(item.plantFarmingName), 1),
                      _createElementVNode("div", null, "物候期：" + _toDisplayString(item.phaseName), 1),
                      _createElementVNode("div", null, "预计人工：" + _toDisplayString(item.plantFarmingArtificial) + "人工/亩", 1),
                      _hoisted_18
                    ])
                  ], 8, _hoisted_16),
                  (item.plantFarmingInfo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(item.plantFarmingInfo), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", {
                      onClick: ($event: any) => (_ctx.onIgnore(item))
                    }, "忽略", 8, _hoisted_21),
                    _createElementVNode("div", {
                      onClick: _withModifiers(($event: any) => (_ctx.onShowDetail(item)), ["prevent"])
                    }, "查看详情", 8, _hoisted_22),
                    _createElementVNode("div", {
                      onClick: ($event: any) => (_ctx.onRecord(item))
                    }, "记录成果", 8, _hoisted_23)
                  ])
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["onBottom"])
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"])
  ]))
}